import React from 'react'
import { connect } from 'react-redux'
import { GET_LIST, showNotification } from 'react-admin'
import { Typography, CircularProgress, Button, Grid, Collapse } from '@material-ui/core'
import { arrayMove, List as MovableList } from 'react-movable'
import MovableItem from '../../movableItem'
import dataProvider from '../../../../../providers'
import { getResource } from '../../../../../config/resources'
import { PATCH } from '../../../../../providers/dataProvider/types'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

class MobileAppsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openList: false,
      mobileApps: [],
      loading: false,
      fetching: false,
    }
  }

  componentDidMount() {
    this.getMobileApps()
  }

  getMobileApps = () => {
    this.setState({ loading: true })
    dataProvider(GET_LIST, getResource('layouts', 'mobile-apps'), {
      sort: {
        field: 'positionApp',
        order: 'ASC',
      },
      pagination: { page: 1, perPage: 20 },
    }).then((res) => this.setState({ mobileApps: res?.data, loading: false }))
  }

  handleChangeOrder = ({ oldIndex, newIndex }) => {
    let newContent = this.state.mobileApps
    newContent = arrayMove(newContent, oldIndex, newIndex)
    newContent = newContent.map((item, index) => ({
      ...item,
      positionApp: index,
    }))
    this.setState({ mobileApps: newContent })
  }

  handleSaveData = () => {
    this.setState({ fetching: true })
    Promise.all(
      this.state.mobileApps.map((mobileApp) => {
        return dataProvider(PATCH, getResource('layouts', 'mobile-apps'), {
          id: mobileApp.id,
          data: mobileApp,
        })
      })
    )
      .then(({ data }) => {
        this.setState({ fetching: false })
        this.props.showNotification('Mobile apps order updated', 'success')
      })
      .catch((error) => {
        this.setState({ error: true, fetching: false })
        this.props.showNotification(error.message, 'error')
      })
  }

  handleClick = () => {
    this.setState({
      openList: !this.state.openList,
    })
  }

  render() {
    return (
      <>
        <div style={{ margin: '29px' }}>
          {this.state.loading ? (
            <div style={{ display: 'flex' }}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px', marginRight: '16px' }}>
                Loading mobile apps
              </Typography>
              <CircularProgress size={24} />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'flex-start' }} onClick={() => this.handleClick()}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px' }}>
                Mobile Apps
              </Typography>
              <div style={{ marginLeft: '16px' }}>{this.state.openList ? <ExpandLess /> : <ExpandMore />}</div>
            </div>
          )}

          {this.state.mobileApps && this.state.openList && (
            <Collapse in={this.state.openList} timeout={350}>
              <Grid item xs={12} lg={8}>
                <div style={{ opacity: this.state.loading ? 0 : 1, transition: 'opacity 350ms' }}>
                  <MovableList
                    lockVertically
                    values={this.state.mobileApps}
                    onChange={this.handleChangeOrder}
                    renderList={({ children, props }) => <div {...props}>{children}</div>}
                    renderItem={({ index, props, isDragged, value }) => {
                      return (
                        <div {...props} key={value.id || index} index={index} style={{ ...props.style, zIndex: 1 }}>
                          <MovableItem isDragged={isDragged} item={value} />
                        </div>
                      )
                    }}
                  />
                  <Grid item justify="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={this.state.loading || this.state.fetching}
                      onClick={() => this.handleSaveData()}
                    >
                      {this.state.fetching ? 'Saving...' : 'Save'}
                    </Button>
                  </Grid>
                </div>
              </Grid>
            </Collapse>
          )}
        </div>
      </>
    )
  }
}

const enhance = connect(null, {
  showNotification,
})

export default enhance(MobileAppsList)
